import { styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
`;

export const Thumbnail = styled.div<{ $image?: string }>`
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 7px;
    background-color: rgba(255, 255, 255, 0.1);
    background-image: url(${({ $image }) => $image});
    background-size: cover;
    background-position: center center;
`;

export const InfoHolder = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0px;
    width: 100%;
    overflow: hidden;
`;

export const AssetName = styled.div`
    overflow: hidden;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;

    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;

    transition: text-shadow 0.2s ease-in-out;

    &:hover {
        text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
    }
`;

export const CollectionName = styled.div`
    overflow: hidden;
    color: rgba(255, 255, 255, 0.5);
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 10px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.2px;
    width: 100%;

    transition: color 0.2s ease-in-out;

    &:hover {
        color: rgba(255, 255, 255, 0.75);
    }
`;
